import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ClaimsState } from './types';
import { RootState } from '@/types';

export const state: ClaimsState = {
    data: {
      data: [],
      links: {},
      metadata: {},
    },
    loading: true,
    error: false,
};

const namespaced: boolean = true;

export const claims: Module<ClaimsState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
